import React from 'react';

import './Checkbox.scss';

let it = 0;

export const merge = {
  TOP: 'top',
  BOTTOM: 'bottom'
};

export default (field) => {
  const name = 'i' + (field.input.name || it++);
  let classes = field.className || '';
  if (field.meta.visited || !field.meta.pristine || field.meta.submitFailed) {
    if (field.meta.valid) {
      classes += ' is-valid';
    } else {
      classes += ' is-invalid';
    }
  }

  const id = (field.id ? field.id : `${field.meta.form}_${name}`).replace('.', '_');

  let mergeClasses = '';
  if (field.merge === merge.TOP) {
    mergeClasses += ' merge-top';
  } else if (field.merge === merge.BOTTOM) {
    mergeClasses += ' merge-bottom';
  }

  return (
    <div className={`btn-checkbox m-1 form-group${mergeClasses}`}>
      <input
        {...field.input}
        checked={field.input.value}
        type="checkbox"
        id={id}
        className={classes}/>
      <label className="btn btn-secondary" htmlFor={id}>{field.label}</label>
    </div>
  );
};